import { Component, ElementRef, HostListener} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GetDataService } from '../../services/userService/get-data.service';

declare function createPopovers():void;

// declare var webkitSpeechRecognition: any;
@Component({
  selector: 'app-chatbot',
  imports: [CommonModule, FormsModule],
  templateUrl: './chatbot.component.html',
  styleUrl: './chatbot.component.scss'
})

export class ChatbotComponent  {
  recognition: any;

  title = 'rules';
  showBoat: boolean = false;
  isExpaned: boolean = false;
  sendBtn: boolean = true;
  loadingResponse: boolean = false;
  private chatbotElement: HTMLElement;
  voice:any;
  chatMsg: any = [];
  userMessage: any = '';

  constructor(private elref: ElementRef, private _service: GetDataService) {
    this.initializeVoiceRecognition();
    this.chatbotElement = this.elref.nativeElement;
    createPopovers();
  }

  showBot() {
    this.showBoat = !this.showBoat;
    const synth = window.speechSynthesis.getVoices();
  }
  
  sendMsg(input: any) {
    window.speechSynthesis.getVoices();
    const message = input.value;
    const synth = window.speechSynthesis.getVoices();
    this.voice =  synth.find(v => v.name.toLowerCase().includes('zira'));
    if (message) {
      // Push user's message immediately
      this.chatMsg.push({
        useRequest: message,
        botResponse: null, // initially null
      });

      // Reset states
      this.loadingResponse = true;
      this.sendBtn = false;
      input.value = '';

      const currentIndex = this.chatMsg.length - 1;

      this._service.getBotResponse(message).subscribe(
        response => {
          this.chatMsg[currentIndex].botResponse = response.response;
          this.loadingResponse = false;
          this.sendBtn = true;
          const chat = document.querySelector(".chatbot-popup-content");
            chat?.scroll({
              top: chat?.scrollHeight,
              behavior:'smooth'})
            if (chat) {
              chat.scrollTop = chat.scrollHeight;
            }
        },
        error => {
          this.loadingResponse = true;
          this.sendBtn = true;
          setTimeout(() => {
            this.loadingResponse = false;
            this.chatMsg[currentIndex].botResponse = "Sorry, something went wrong.";
            const chat = document.querySelector(".chatbot-popup-content");
            chat?.scroll({
              top: chat?.scrollHeight,
              behavior:'smooth'})
            if (chat) {
              chat.scrollTop = chat.scrollHeight;
            }
          }, 1000);
          console.error("Error:", error);
        }
      );
    }
  }

  copyToClipboard(text: string): void {

    if (navigator.clipboard) {
      // Modern Clipboard API
      navigator.clipboard.writeText(text)
        .then(() => {
        })
        .catch(err => {
          console.error('Failed to copy text: ', err);
        });
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    if (!this.chatbotElement.contains(event.target as HTMLElement)) {
      this.showBoat = false;
    }
  }

  expandBot() {
    this.isExpaned = !this.isExpaned;
  }


  readResponse(text: string) {
    const speech = new SpeechSynthesisUtterance();
    speech.text = text;
    speech.lang = 'en-US'; // Change as needed
    speech.rate = 1; // Speed of voice (0.1 - 10)
    speech.pitch = 1; // Pitch (0-2)
    speech.volume = 1; // Volume (0-1)
    speech.voice = this.voice;


    // Optional: Cancel any ongoing speech before starting new
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(speech);
  }

  initializeVoiceRecognition() {

    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;

    if (SpeechRecognition) {
      this.recognition = new SpeechRecognition();
      this.recognition.lang = 'en-US';
      this.recognition.interimResults = false;
      this.recognition.maxAlternatives = 1;

      this.recognition.onresult = (event: any) => {
        const spokenText = event.results[0][0].transcript;
        this.sendMsg({ value: spokenText }); // send it like a typed message
      };

      this.recognition.onerror = (event: any) => {
        console.error("Speech recognition error:", event.error);
      };
    } else {
      alert("Your browser does not support speech recognition.");
    }
  }

  Popup(event:MouseEvent){
    createPopovers();
  }

  getMsg(){
    return `
    <p><small>
    <b>Use keyword :  "difference" , "changes", "new", "short", "describe", "explain", "details"</b></small></p>
    <b>Questions like :</b>
    <span class="rounded-3 text-dark bg-light">
      <p><b>Ex. 1 : </b>  Explain amendment to rule 67 in <b> <i> short</i></b>.</p>
    </span>
    <span class="rounded-3 text-dark bg-light">
      <p><b>Ex. 2 : </b>What are the <b><i>changes</i></b> in rule 70 ?</p>
    </span>
    `;
  }

  startVoiceInput() {
    if (this.recognition) {
      this.recognition.start();
    }

    setInterval(() => {
      document.getElementById("chat");
    }, 10);
  }

}
